import React, { useEffect, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import inventory from "../../../Data/inventory.json";
import products from "../../../Data/products.json";
import {
  get_all_inventories,
  delete_inventory,
  delete_multiple_inventories,
  delete_all_expired_inventories
} from "../../../Controllers/Inventory/Batch";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_inventories_expired_reports } from "../../../Controllers/Dashboard/Dashboard";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import { Checkbox, Button, Modal } from "antd";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import FeatureLockWrapper from "../../../Componets/FeatureLocksWrapper";
import StockFL from "../../../Componets/FormatStock";

const { confirm } = Modal;

const InventoryExpiredDashboard = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const Dashboard_Branch = localStorage.getItem("Dashboard_Branch");

  useEffect(() => {
    const fetchFeatureUnlocks = async () => {
      const Expired = await FeatureLockWrapper.isFeatureUnlocked("expired_inventory_bulk_delete");
      setIsUnlocked(Expired);
    };
    fetchFeatureUnlocks();
  }, []);


  const headers = {
    name: "Inventory batch",
    pagination: {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    },
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        value: null,
        allowClear: true,
        options: [
          { value: "1", label: "Name (A-Z)" },
          { value: "2", label: "Name (Z-A)" },
          { value: "3", label: "Expiry (ASC)" },
          { value: "4", label: "Expiry (DES)" },
          { value: "5", label: "Purchase (Low)" },
          { value: "6", label: "Purchase (High)" },
          { value: "7", label: "Sale (Low)" },
          { value: "8", label: "Sale (High)" },
        ],
      },
      {
        type: "filter",
        name: "product",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Product",
        api: "get-all-products",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    setSelectedItems([]);
    setSelectAll(false);
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
        branch: tabledata?.branch ? tabledata?.branch : Dashboard_Branch ? Dashboard_Branch : "",
      };

      const products = await get_all_inventories_expired_reports(data);

      console.log("spspsppspsps", products)
      if (products?.status) {
        setBody(products?.data?.expired_data || []);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };


  const handleSelectItem = (id) => {
    setSelectedItems(prev =>
      prev.includes(id)
        ? prev.filter(itemId => itemId !== id)
        : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      const allIds = body?.map(item => item._id);
      setSelectedItems(allIds);
    }
    setSelectAll(!selectAll);
  };

  const handleDeleteSingle = (id, productName) => {
    confirm({
      title: `Are you sure you want to delete ${productName}?`,
      icon: <ExclamationCircleFilled />,
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteSingleInventory(id);
      },
    });
  };

  const deleteSingleInventory = async (id) => {
    try {
      setDeleteLoader(true);
      const result = await delete_inventory({ id });

      if (result?.status) {
        toast.success(result.message);
        setBody(prev => prev.filter(item => item._id !== id));
        setSelectedItems(prev => prev.filter(itemId => itemId !== id));
      } else {
        toast.error(result?.message || "Failed to delete inventory");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setDeleteLoader(false);
    }
  };

  const handleDeleteMultiple = () => {
    if (selectedItems.length === 0) {
      toast.error("Please select items to delete");
      return;
    }

    confirm({
      title: `Are you sure you want to delete ${selectedItems.length} selected items?`,
      icon: <ExclamationCircleFilled />,
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteMultipleInventories();
      },
    });
  };

  const deleteMultipleInventories = async () => {
    try {
      setDeleteLoader(true);
      const result = await delete_multiple_inventories({ ids: selectedItems });

      if (result?.status) {
        toast.success(result.message);
        setBody(prev => prev.filter(item => !selectedItems.includes(item._id)));
        setSelectedItems([]);
        setSelectAll(false);
      } else {
        toast.error(result?.message || "Failed to delete inventories");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setDeleteLoader(false);
    }
  };

  const handleDeleteAllExpired = () => {
    if (body.length === 0) {
      toast.error("No expired items to delete");
      return;
    }

    confirm({
      title: `Are you sure you want to delete ALL ${body.length} expired items?`,
      icon: <ExclamationCircleFilled />,
      content: 'This action cannot be undone and will delete all expired inventories.',
      okText: 'Yes, Delete All',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteAllExpiredInventories();
      },
    });
  };

  const deleteAllExpiredInventories = async () => {
    try {
      setDeleteLoader(true);
      const currentFilters = {
        search: header.components[0].value,
        sort: header.components[1].value,
        date: header.components[3].value,
        product: header.components[2].value,
      };

      const result = await delete_all_expired_inventories(currentFilters);

      if (result?.status) {
        toast.success(result.message);
        setBody([]);
        setSelectedItems([]);
        setSelectAll(false);
      } else {
        toast.error(result?.message || "Failed to delete expired inventories");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setDeleteLoader(false);
    }
  };

  useEffect(() => {
    setSelectAll(selectedItems.length === body.length && body.length > 0);
  }, [selectedItems, body]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        {isUnlocked && (
          <div className="flex justify-between items-center p-4 bg-gray-50 rounded-lg mt-4">
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">
                {selectedItems.length} of {body.length} selected
              </span>
              {selectedItems.length > 0 && (
                <Button
                  type="primary"
                  danger
                  icon={<DeleteOutlined />}
                  loading={deleteLoader}
                  onClick={handleDeleteMultiple}
                >
                  Delete Selected ({selectedItems.length})
                </Button>
              )}
            </div>
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              loading={deleteLoader}
              onClick={handleDeleteAllExpired}
              disabled={body.length === 0}
            >
              Delete All Expired ({body.length})
            </Button>
          </div>
        )}

        <ScrollWrapper >
          <table className="w-full bg-white mt-4">
            <thead className="text-gray-500">
              <tr>
                {isUnlocked && (<td className="border p-4">
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    disabled={body.length === 0}
                  />
                </td>)}
                <td className="border p-4">S.No</td>
                <td className="border p-4">Name</td>
                <td className="border p-4">Supplier</td>
                <td className="border p-4">Batch</td>
                <td className="border p-4">Expiry</td>
                <td className="border p-4">Tax</td>
                <td className="border p-4">Stock</td>
                <td className="border p-4">Sale</td>
                <td className="border p-4 text-center">Total Sale Price</td>
                <td className="border p-4">Actions</td>
              </tr>
            </thead>
            <tbody>
              {body?.map((value, index) => {
                const isSelected = selectedItems.includes(value._id);
                return (
                  <tr key={value._id} className={isSelected ? 'bg-blue-50' : ''}>
                    {isUnlocked && (<td className="border p-4">
                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleSelectItem(value._id)}
                      />
                    </td>)}
                    <td className="border p-4">{index + 1}</td>
                    <td className="border p-4">{value?.product?.name}</td>
                    <td className="border p-4">{value?.supplier?.name}</td>
                    <td className="border p-4">{value?.number}</td>
                    <td className="border p-4">
                      {value?.expiry_date
                        ? formatDateDDMMYYYY?.(value?.expiry_date)
                        : ""}
                    </td>
                    <td className="border p-4">{value?.tax?.rate || "0%"}</td>
                    <td className="border p-4">
                      <StockFL
                        totalStock={value?.stock}
                        conversion={
                          value?.product_units_details?.[0]?.conversion || 1
                        }
                      />
                    </td>
                    <td className="border p-4">
                      {value?.sale_price?.toFixed?.(3)}
                    </td>
                    <td className="border p-4 text-center font-bold">
                      {(value?.stock * value?.sale_price).toFixed(3)}
                    </td>
                    <td className="border p-4">
                      <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        loading={deleteLoader}
                        onClick={() => handleDeleteSingle(value._id, value?.product?.name)}
                        size="small"
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td className="border p-4" colSpan="8">
                  <strong>Totals:</strong>
                </td>
                {/* <td className="border p-4"></td>
                <td className="border p-4"></td> */}
                <td className="border p-4">
                  {/* <div className="font-semibold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.sale_price),
                        0
                      )
                      ?.toFixed(3)}
                  </div> */}
                </td>
                <td className="border p-4">
                  <div className="font-bold text-center">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          acc +
                          ((parseFloat(currentValue?.stock) || 0) *
                            (parseFloat(currentValue?.sale_price) || 0)),
                        0
                      )
                      ?.toFixed(3)}
                  </div>
                </td>
                <td className="border p-4"></td>
              </tr>
            </tfoot>
          </table>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default InventoryExpiredDashboard;